import { useState } from "react";
import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import { putActivateGiftCard } from "@utils/call-api/gift-cards-call";
import { Input, Button } from "@components/core";

const GiftCardRedeemCode = () => {
  const t = useTranslations("gift_cards");

  const router = useRouter();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function checkRedeemCode(e, redeemCode) {
    e.preventDefault();

    setLoading(true);
    try {
      setError(null);
      const res = await putActivateGiftCard(redeemCode);

      if (res.data.amount) {
        router.replace(`/activate_gift_cards/success?amount=${res.data.amount}`);
      }
    } catch (err) {
      setLoading(false);
      if (err.data.errors) return setError(t("error_occured"));

      if (err.data.response.reason) {
        setError(err.data.response.reason);
      } else {
        setError(t("error_occured"));
      }
    }

    return null;
  }

  return (
    <div className="reedem-input-container d-flex align-items-center justify-content-center mb-4">
      <div>
        <form onSubmit={(e) => checkRedeemCode(e, code)}>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <Input
              type="text"
              label={t("gift_card_code")}
              placeholder={t("gift_card_code")}
              name="redeem_code"
              required
              value={code}
              onChange={(e) => setCode(e.currentTarget.value)}
            />
            <Button
              type="submit"
              className="mt-3"
              loading={loading}
            >
              {t("activate")}
            </Button>
          </div>
        </form>
        {error && <span className="font-size-sm mt-1 text-danger">{error}</span>}
      </div>
    </div>
  );
};

export default GiftCardRedeemCode;
